import { IconListFilled } from '@gmg/gmg-react-components';
import { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SearchBox from 'src/components/shared/SearchBox';
import { useGetActivitiesByOrgId } from 'src/graphql/useGetActivitiesByOrgId';
import ActivityListContainer from './ActivityListContainer';
import AppContext from 'src/AppContext';
import OrganizationContainer from '../OrganizationContainer';

const OrganizationActivityContainer: FC = () => {
    const { t } = useTranslation();
    const { orgId = '' } = useParams<{ orgId: string }>();
    const context = useContext(AppContext);
    const [cursorToRequest, setCursorToRequest] = useState<string | null>(null);
    const [filterValue, setFilterValue] = useState<string>('');
    const { data, isFetching, error } = useGetActivitiesByOrgId(orgId, cursorToRequest);

    const requestPage = useCallback((cursor: string | null) => {
        setCursorToRequest(cursor);
    }, []);

    useEffect(() => {
        if (!error) {
            return;
        }
        context.onError(error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return (
        <OrganizationContainer
            onOrganizationLoad={() => { }}
            viewInfo={{
                icon: <IconListFilled width={16} height={16} />,
                label: t('HeaderPageTitles.all_activity_title', 'Activity'),
            }}
            searchBar={
                <SearchBox
                    onChange={(e) => setFilterValue(e.target.value)}
                    value={filterValue}
                />
            }
        >
            <ActivityListContainer
                data={data}
                isFetching={isFetching}
                requestPage={requestPage}
                isGmGAdminView={false}
                filterValue={filterValue}
            />
        </OrganizationContainer>
    );
};

export default OrganizationActivityContainer;
